import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/numerosinutilizados/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findUnusableNumbers({
  empresa_cnpj,
  where = {},
  orWhere = [],
  isSameOrWhere = false,
}) {
  let queryOrWhere = "";
  orWhere.forEach((row, key) => {
    Object.keys(row).forEach((key) => {
      queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
        row[key]
      }`;
    });
  });

  let query = "";
  Object.keys(where).forEach((value, index) => {
    query += `&where[${value}]=${where[value]}`;
  });

  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${query}${queryOrWhere}`,
    "GET",
    headers
  );
}

export async function saveNumber(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export async function sendNumbers(empresa_cnpj, body) {
  return search(
    `${path}/transmit?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}
